import Service from './Service';


export default class Offer {
	constructor(dto) {
		dto = dto || {};
		const {offerTemplate = {}} = dto;

		this.code = offerTemplate.code;
		this.description = offerTemplate.description;
		this.name = offerTemplate.name;
		this.longDescription = offerTemplate.longDescription;
		this.disabled = offerTemplate.disabled;
		this.bomCode = offerTemplate.bomCode;
		this.imagePath = offerTemplate.imagePath || "fnac.PNG";
		this.offerTemplateCategoryCode = offerTemplate.offerTemplateCategoryCode;
		this.image = OPENCELL_PATH + "/picture/" + provider + "/offer/" + offerTemplate.imagePath;
		this.termsAndConditions = offerTemplate.termsAndConditions || "./assets/Opencell_terms_and_conditions.pdf";
		this.customFields = offerTemplate.customFields && offerTemplate.customFields.customField || [];
		this.offerTemplateCategory = offerTemplate.offerTemplateCategory || [];


		let {offerServiceTemplate} = offerTemplate || {};
		offerServiceTemplate = offerServiceTemplate || [];
		this.offerServices = [];
		offerServiceTemplate.forEach(Template => {
			Template = Template || {};
			this.offerServices.push(
				new Service(Template.serviceTemplate,
					Template.mandatory,
					Template.incompatibleServiceTemplate));
		});
		this.renewalRule = offerTemplate.renewalRule; 
	}
}



// WEBPACK FOOTER //
// ./src/opencell/model/catalog/Offer.js